import React, {useEffect, useState, lazy, Suspense} from "react"
import { Route, Routes } from "react-router-dom"
import '../src/app.scss'
import Navbar from './Components/Navbar/Navbar'
import { Home } from "./Pages/Home/Home"
import About from "./Pages/About/About";
import ContactPage from "./Pages/ContactPage/ContactPage";
import WorkPage from "./Pages/WorkPage/WorkPage";
import SkillsPage from "./Pages/SkillsPage/SkillsPage";
import Loader from "./Components/Loader/Loader"

import "./smoothScroll"

//lazy load project page
const Project = lazy(() => wait(2100).then(() => import("./Pages/Project/Project")))

function App() {
  const [triggerReload, setTriggerReload] = useState(true)
  useEffect(() => {
    window.addEventListener("resize", () => {
      if(window.innerWidth<550 && window.innerWidth>548){
        window.location.reload()
        setTriggerReload(false)
      }
    })
  })

  return (
    <div className="wrapper main-wrapper" id="app-wrapper">
      <Navbar />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route exact path="/" element={<Home currentPage="home"/>} />
          <Route path="/about" element={<About currentPage="about"/>} />
          <Route path="/contact" element={<ContactPage currentPage="contact"/>} />
          <Route path="/projects" element={<WorkPage currentPage="projects"/>} />
          <Route path="/:id" element={<Project />}/>
          <Route path="/skills" element={<SkillsPage currentPage="skills"/>} />
        </Routes>
      </Suspense>
    </div>
  )
}

function wait(time) {
  return new Promise(resolve => {
    setTimeout(resolve, time)
  })
}

export default App;
